package tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info

import tta.destinigo.talktoastro.shared.data.RechargeData


sealed class CallConsultationEvent {
    data class OnNavigateRechargeCheckOut(
        val rechargeData: RechargeData?
    ): CallConsultationEvent()
}